// @flow

export const Primary: 'Primary' = 'Primary';
export const White: 'White' = 'White';
export const Black: 'Black' = 'Black';
